<div
  id="carousel"
  class="flex h-full w-full flex-col"
  [ngClass]="{
    'fixed inset-0 z-50 flex items-center justify-center bg-black bg-black/70 bg-opacity-80 backdrop-blur-lg':
      isFullscreen(),
  }"
>
  <div class="relative z-50 w-full">
    @if (index !== 0) {
      <div
        class="absolute z-50 flex h-full flex-col justify-center"
        [ngClass]="isFullscreen() ? 'left-5' : 'left-2'"
      >
        <div
          class="flex items-center justify-center rounded-full bg-bo-primary"
          [ngClass]="isFullscreen() ? '!size-14' : '!size-10'"
        >
          <svg-icon
            src="fa-icons/chevron-left.svg"
            class="fill-bo-white"
            [svgStyle]="{ 'height.px': isFullscreen() ? 32 : 16 }"
            (click)="changeIndex(-1)"
          />
        </div>
      </div>
    }
    @if (index !== images().length - 1) {
      <div
        class="absolute z-50 flex h-full flex-col justify-center"
        [ngClass]="isFullscreen() ? 'right-5' : 'right-2'"
      >
        <div
          class="flex items-center justify-center rounded-full bg-bo-primary"
          [ngClass]="isFullscreen() ? '!size-14' : '!size-10'"
        >
          <svg-icon
            src="fa-icons/chevron-right.svg"
            class="fill-bo-white"
            [svgStyle]="{ 'height.px': isFullscreen() ? 32 : 16 }"
            (click)="changeIndex(+1)"
          />
        </div>
      </div>
    }
    @if (isFullscreen()) {
      <div
        class="absolute right-5 top-5 z-50 flex size-14 items-center justify-center rounded-full bg-bo-black/65 backdrop-blur-md"
        (click)="this.isFullscreen.set(false)"
      >
        <svg-icon
          src="fa-icons/xmark.svg"
          class="fill-bo-white"
          [svgStyle]="{ 'height.px': 32 }"
        />
      </div>
    }
    <div
      class="no-scrollbar relative flex w-full snap-x snap-mandatory overflow-x-auto rounded-lg"
    >
      @for (image of images(); track image; let i = $index) {
        <div
          class="w-full flex-none snap-center"
          btSwipe
          (swipeLeft)="onSwipeLeft()"
          (swipeRight)="onSwipeRight()"
          (click)="this.isFullscreen.set(!isFullscreen())"
        >
          <img [src]="image" [id]="'image' + i" class="w-full object-cover" />
        </div>
      }
    </div>
  </div>
</div>
